import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const QuestionAnswerMultipleChoice = ({ question, renderAnswerOption }) => {
    var _a, _b, _c;
    const questionContent = JSON.parse((_a = question.questionContent) !== null && _a !== void 0 ? _a : '{}');
    let { userAnswer } = JSON.parse((_c = (_b = question.questionAnswer) === null || _b === void 0 ? void 0 : _b.rawAnswer) !== null && _c !== void 0 ? _c : '{}');
    userAnswer = userAnswer === undefined ? [] : userAnswer;
    return (_jsx("ul", Object.assign({ className: "list list--exams-grading" }, { children: questionContent.answers.map((option) => {
            return renderAnswerOption(option.isAnswer, userAnswer.includes(option.index), option.index, option.title);
        }) }), void 0));
};
export default QuestionAnswerMultipleChoice;
